import InteractionEvent, {
  type InteractionTargetType
} from './InteractionEvent';

export type ContentLinkTargetProperties = {
  destination_path?: string;
  destination_url?: string;
};

type EventData = {
  gesture?: string;
  guestId?: string;
  href: string;
  isBot: boolean;
};

class ContentLinkInteractionEvent extends InteractionEvent<
  EventData,
  ContentLinkTargetProperties
> {
  protected get targetType(): InteractionTargetType {
    return 'content_link';
  }

  protected getTargetProperties(): ContentLinkTargetProperties {
    const destination = new URL(this.data.href, window.location.origin);

    return destination.origin === window.location.origin
      ? { destination_path: `${destination.pathname}${destination.search}` }
      : { destination_url: destination.href };
  }
}

export default ContentLinkInteractionEvent;
